import SecureLS from "secure-ls";

const encryptionSecret = (process.env.SECURELS_SECRET) || '';
const securels = new SecureLS({ encodingType: 'aes', isCompression: true, encryptionSecret });
export { securels };
